// TODO align these further with rework and possibly move to eventData.ts
export const elementEngaged = 'VDP Element Engaged';
export const moduleViewed = 'VDP Module Viewed';

export enum ActionTaken {
  Left = 'left',
  Next = 'next',
  Previous = 'previous',
  Right = 'right'
}

export enum Action {
  Clicked = 'clicked',
  Dragged = 'dragged',
  Pinched = 'pinched',
  Scrolled = 'scrolled',
  Swiped = 'swiped'
}
